import { Accordion, Row, StatsAtBatPromotion, createCssVariableString } from "best-common-react";
import React from "react";
import styled from "styled-components";

const HeaderText = styled.span`
  color: ${createCssVariableString("onColorsOnSurfaceLow")};
  font-size: 12px;
  font-weight: bold;
`;

const PreviewHolder = styled.div`
  margin-left: 0.25rem;
  color: ${createCssVariableString("onColorsOnSurfaceLow")};
  font-size: 0.75rem;
  font-weight: 300;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const PromotionHolder = styled.div.attrs({ className: "col-md-6 col-xl-4" })`
  display: flex;
  margin-top: 0.75rem;
  padding: 0 2rem;
  color: ${createCssVariableString("onColorsOnSurfaceLow")};
`;

const PromotionName = styled.span`
  display: block;
  font-size: 0.875rem;
  font-weight: bold;
`;

const PromotionDesc = styled.p`
  margin: 0.25rem 0;
  font-size: 12px;
`;

const PromotionInfo = styled.span`
  font-size: 11px;
  font-weight: bold;
`;

const ImageHolder = styled.div`
  width: 30%;
  margin-right: 0.75rem;
`;

const Container = styled.div`
  box-shadow: ${createCssVariableString("bcr-shadows")};
`;

const Promotion = ({ name, imageUrl, description, presentedBy, distribution }: StatsAtBatPromotion) => {
  const info = presentedBy && `${presentedBy} | ` + !distribution ? "All Fans" : distribution;
  return (
    <PromotionHolder>
      <ImageHolder>
        <img className="w-100" src={imageUrl} alt="" />
      </ImageHolder>
      <div style={{ width: "70%" }}>
        <PromotionName>{name}</PromotionName>
        <PromotionDesc>{description}</PromotionDesc>
        <PromotionInfo>{info}</PromotionInfo>
      </div>
    </PromotionHolder>
  );
};

const Promotions = ({ gamePk, promotions }: { gamePk: string | number; promotions?: null | StatsAtBatPromotion[] }) => {
  if (!!promotions) {
    const preview = promotions?.length === 1 ? promotions[0].name : `(${promotions.length})`;
    return (
      <Container>
        <Accordion accordionKey={gamePk.toString()}>
          <Accordion.Header iconLeft={true}>
            <div className="d-flex">
              <HeaderText>{promotions.length === 1 ? "Promotion:" : "Promotions:"}</HeaderText>
              <PreviewHolder>{preview}</PreviewHolder>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <Row>
              {promotions.map((promotion, index) => (
                <Promotion key={`promotion-${index}`} {...promotion} />
              ))}
            </Row>
          </Accordion.Body>
        </Accordion>
      </Container>
    );
  } else {
    return null;
  }
};

export default Promotions;
